import { useTranslation } from 'react-i18next';
import * as S from './MissingAdNotice.styles';
import { AdPageTestIds } from '@/__e2e__/testIds/ad-page';

export const MissingAdNotice = () => {
  const { t } = useTranslation();

  return (
    <S.MissingAdContainer data-testid={AdPageTestIds.missingAd.container}>
      <S.MissingAdTitle data-testid={AdPageTestIds.missingAd.title}>
        {t('pages.ad.nothing_found')}
      </S.MissingAdTitle>
      <S.MissingAdText data-testid={AdPageTestIds.missingAd.description}>
        {t('pages.ad.nothing_found_ad_description')}
      </S.MissingAdText>
    </S.MissingAdContainer>
  );
};
